<template lang="pug">
.map(ref='map')
</template>

<script>
import { api } from '@/api'
import MarkerClusterer from '@google/markerclusterer'
import { bus } from '@/bus.js'

export default {
  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    },
    filters: {
      type: Object,
      default() {
        return {}
      }
    },
    sortingOrder: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data () {
    return {
      coordinates: [],
      map: null,
      markers: [],
      position: {lat: parseFloat(this.property.lat), lng: parseFloat(this.property.lon)},
      infoWindow: new google.maps.InfoWindow(),
      markerCluster: {},
      currentSortingOrder: this.sortingOrder
    }
  },

  computed: {
    radius() {
      return (this.filters.radius ? this.filters.radius : 0)
    },

    zoom() {
      if (this.radius >= 5000 && this.radius < 9000) {
        return 12
      } else if (this.radius >= 9000) {
        return 11
      } else {
        return 13
      }
    },

    loadCoordinatesUrl() {
      return `properties/${this.$route.params.id}/rooms/${this.$route.params.room_id}/competitors/coordinates`
    }
  },

  mounted() {
    this.loadCoordinates()
    this.initMap()
    this.initPropertyMarker()
    this.initCircle()
  },

  methods: {
    loadCoordinates() {
      const params = {
        filters: this.filters,
        order: this.currentSortingOrder,
        property_id: this.$route.params.id
      }

      api.get(this.loadCoordinatesUrl, { params })
        .then(({ data: { data: coordinates } }) => {
          this.coordinates = coordinates
          this.initCompetitorMarkers()
        })
    },

    initMap() {
      this.map = new google.maps.Map(this.$refs.map, {
        center: this.position,
        zoom: this.zoom
      })
    },

    initPropertyMarker() {
      let icon = require('@/assets/property.png')

      this.propertyMarker('', this.position, icon)
    },

    initCompetitorMarkers() {
      let marker, position = null;
      let icon = require('@/assets/competitor.png')
      this.markers = []

      this.coordinates.forEach((item) => {
        position = { lat: parseFloat(item.location_lat), lng: parseFloat(item.location_lon) }
        marker   = this.competitorMarker(String(item.number), position, icon)
        this.markers.push(marker)

        google.maps.event.addListener(marker, 'click', ((marker, item) => {
          return () => {
            const infoWindow = new google.maps.InfoWindow()
            infoWindow.setContent(this.contentString(item))
            infoWindow.open(this.map, marker)
            bus.$emit('clickTooltip', Number(marker.label.text))
          }
        })(marker, item))
      })
      this.markerCluster = new MarkerClusterer(
        this.map,
        this.markers,
        { imagePath: '/assets/marker-cluster/m', maxZoom: 21 }
      )
    },

    competitorMarker(label, position, icon) {
      return new google.maps.Marker({
        position: position,
        labelAnchor: { x: 3, y: 33 },
        label: {
          text: label,
          color: '#fff'
        },
        icon: this.icon(icon)
      });
    },

    propertyMarker(label, position, icon) {
      return new google.maps.Marker({
        position: position,
        map: this.map,
        labelAnchor: { x: 3, y: 33 },
        icon: this.icon(icon)
      });
    },

    initCircle() {
      new google.maps.Circle({
        strokeColor: '#1CACEC',
        strokeOpacity: 0.8,
        strokeWeight: 0,
        fillColor: '#1CACEC',
        fillOpacity: 0.35,
        map: this.map,
        center: this.position,
        radius: this.radius
      })
    },

    icon(icon_path) {
      return {
        url: icon_path,
        labelOrigin: { x: 23, y: 16 }
      };
    },

    contentString(item) {
      return (`
        <div id="content">
          <div id="siteNotice"></div>
          <div id="bodyContent">
            <p>
              <div>${item.property_name}</div>
              <div>${item.min_price}~${item.max_price}</div>
            </p>
          </div>
        </div>
      `);
    }
  }
}
</script>

<style lang="scss" scoped>
  .map {
    height: 350px;
  }
</style>
